import React, { Fragment } from "react";
import {isVariantAvailableForSale} from '../../../utils/checkVariantAvailability';

const VariantDropdown = ({
  title = "",
  variantKey = "",
  optionKey = "",
  changeVariant,
  options = [],
  variants = [],
  selectedOptions = [],
  hideLabel = false,
}) => {
  return (
      <Fragment>
        <p className="mt-[6px] mb-[10px]">{hideLabel ? "" : title}</p>
        <select
            className="text-[13px] min-w-[150px] rounded-full border-2 border-solid border-black max-w-fit h-10 pl-2 pr-4 focus-visible:outline-none"
            onChange={(e) => changeVariant(variantKey, e.target.value)}
        >
          {options?.map((option, index) => {
            const isAvailable = isVariantAvailableForSale(variantKey, selectedOptions, variants, optionKey, option);
            return (
              <option
                  key={index}
                  className="text-black bg-white"
                  value={option}
                  disabled={!isAvailable}
              >
                {option}
              </option>
          )})}
        </select>
      </Fragment>
  );
};

export default VariantDropdown;
